import React, {
  Component,
} from 'react';
import 'react-input-range/lib/css/index.css';
import {
  Manager,
  Reference,
  Popper,
} from 'react-popper';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import './style.css';
import { debounce } from 'lodash';
import { getSearchSuggestions } from '../../actions/api';
import {getSelectedCustomerType, isStrictMedicalCustomerType} from '../../selectors/customer_type_selector';
import { SEARCH_SUGGESTION_DEBOUNCE_INTERVAL } from './search_const';

import { 
  isAnyOptions,
  getSearchQueryUrl,
} from '../../helpers/searchBarHelper';
import Suggestions from './Suggestions';
import { closeIfOpenAdvancedFilter } from '../../reducers/filterReducer';
import { scrollTo } from '../../actions/view';
import { disableBodyOverflow, enableBodyOverflow } from '../../helpers/scroll';
import { getSalesChannelName } from '../../selectors/sales_channel_selectors';
import { push } from 'connected-react-router';

class SearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchString: '',
      isDropdownResultOpen: false,
      results: {
        brands: [],
        types: [],
        subTypes: [],
        products: [],
        classifications: [],
        flavors: [],
        generals: [],
        effects: [],
      },
    };

    this.debouncedSuggestions = debounce(this.search, SEARCH_SUGGESTION_DEBOUNCE_INTERVAL);
  }

  saveResult = (suggestions) => {
    const {
      searchString,
    } = this.state;

    let results = [];

    if (searchString !== '') {
      results = suggestions;
    }

    this.setState({
      results,
    }, () => {
      if (isAnyOptions(results)) {
        disableBodyOverflow();
      } else {
        enableBodyOverflow();
      }
    });
  }

  handleChangeSearch = async (e) => {
    const searchString = e.target.value;

    this.setState({ searchString, isDropdownResultOpen: true });
    if (!searchString) {
      enableBodyOverflow();
    }
    this.debouncedSuggestions(searchString);
  };

  setVisibleDropdownResults = (isOpen) => {
    this.setState({ isDropdownResultOpen: isOpen });
    if (isOpen && isAnyOptions(this.state.results)) {
      disableBodyOverflow();
    } else {
      enableBodyOverflow();
    }
  }

  handleSuggestionClick = () => {
    this.onClose();
  }

  clearSearchString = () => {
    this.setState({
      searchString: '',
    });
  }

  clearSearchResults = () => {
    this.setState({
      results: [],
    });
  }

  search = (searchString) => {
    if (!searchString) {
      this.clearSearchResults();
      return;
    }

    const {
      customerType,
      salesChannelName,
      strictMedicalCustomerType,
    } = this.props;

    getSearchSuggestions(
      searchString,
      customerType,
      salesChannelName,
      strictMedicalCustomerType,
    )
      .then(({data}) => {
        if (!data && !data.data) {
          enableBodyOverflow();
          return;
        }

        const suggestions = data.data;
        this.saveResult(suggestions);
      });
  };

  onClose = () => {
    const {
      resetScrollPosition,
    } = this.props;

    this.clearSearchString();
    resetScrollPosition();
    enableBodyOverflow();
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.setVisibleDropdownResults(false);
    this.onClose();
    this.props.go(
      getSearchQueryUrl(
        this.state.searchString,
      ),
    );
  }

  render() {
    const {
      results,
      isDropdownResultOpen
    } = this.state;

    const {
      brands,
      types,
      subTypes,
      products,
      classifications,
      flavors,
      generals,
      effects,
    } = results;

    return (
      <div id="search-bar" className={this.props.className}>
        <Manager className="search-bar-container">
          <Reference>
            {({ ref }) => (
              <form
                onSubmit={this.onSubmit}
              >
                <div className="search">
                  <input
                    placeholder="Search products"
                    autoComplete="off"
                    onChange={this.handleChangeSearch}
                    onFocus={() => this.setVisibleDropdownResults(true)}
                    onBlur={() => setTimeout(() => this.setVisibleDropdownResults(false), 300)}
                    onClick={() => this.setVisibleDropdownResults(true)}
                    spellCheck={false}
                    value={this.state.searchString}
                    ref={ref}
                  />
                </div>
              </form>
            )}
          </Reference>
          {isAnyOptions(this.state.results)
              && isDropdownResultOpen && (
              <Popper placement="bottom-start">
                {({ placement, ref, style }) => (
                  <div ref={ref} style={{ ...style, ...{ overflowY: 'scroll', height: '90vh' } }} data-placement={placement} className="search-results">
                    <div className="results-padding" />
                    <Suggestions
                      types={types}
                      subTypes={subTypes}
                      products={products}
                      brands={brands}
                      classifications={classifications}
                      flavors={flavors}
                      effects={effects}
                      generals={generals}
                      isPhone={false}
                      customerType={this.props.customerType}
                    />

                    <Link
                      onClick={this.handleSuggestionClick}
                      className="search-result text-center"
                      to={getSearchQueryUrl(this.state.searchString)}>
                      <div className="result-title ">
                        View all results
                      </div>
                    </Link>
                  </div>
                )
                }
              </Popper>
          )
          }
        </Manager>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  secondaryColor: `#${state.config.secondaryColor}`,
  customerType: getSelectedCustomerType(state),
  salesChannelName: getSalesChannelName(state),
  strictMedicalCustomerType: isStrictMedicalCustomerType(state),
});

const mapDispatchToProps = dispatch => ({
  go: (uri) => dispatch(push(uri)),
  closeIfOpenAdvancedFilter: () => dispatch(closeIfOpenAdvancedFilter()),
  resetScrollPosition: () => dispatch(scrollTo(0)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);



// WEBPACK FOOTER //
// ./src/components/Search/SearchBar.jsx